module.exports = __webpack_public_path__ + "img/1_032.37bda28a.jpg";